// Hallmark Accordion Logic
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.acc-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.acc-item');
      if (item) {
        item.classList.toggle('open');
      }
    });
  });
});
